import { Route, Switch } from "@hyperapp/router";
import { h } from "hyperapp";

import navSidebarCSS from "../common/navsidebar/navsidebar.css";
import { main as places } from "../sections/places/main";
import { main as scheduling } from "../sections/scheduling/main";
import { main as unvisitedPlacesNearby } from "../sections/unvisited-places-nearby/main";
import { main as unvisitedPlaces } from "../sections/unvisited-places/main";

export const sidebar = ({ actions, state, translations }) => {
  return (
    <Switch>
      {Route({
        path: "/",
        render: () => (
          <div
            class={navSidebarCSS.container}
            onclick={event =>
              actions.autocloseSidebar({
                className: navSidebarCSS.main,
                event,
              })
            }
          >
            {/* {navSidebar({ actions, state })} */}
            {places({
              actions,
              section: "places",
              state,
              translations: translations.translations,
            })}
          </div>
        ),
      })}
      {Route({
        path: "/unvisited-places",
        render: () => (
          <div
            class={navSidebarCSS.container}
            onclick={event =>
              actions.autocloseSidebar({
                className: navSidebarCSS.main,
                event,
              })
            }
          >
            {unvisitedPlaces({
              actions,
              section: "unvisitedPlaces",
              state,
              translations:
                translations.translations["unvisitedPlaces"][state.language],
            })}
          </div>
        ),
      })}
      {Route({
        path: "/unvisited-places/nearby",
        render: () => (
          <div
            class={navSidebarCSS.container}
            onclick={event =>
              actions.autocloseSidebar({
                className: navSidebarCSS.main,
                event,
              })
            }
          >
            {unvisitedPlacesNearby({
              actions,
              section: "unvisitedPlacesNearby",
              state,
              translations:
                translations.translations["unvisitedPlacesNearby"][
                  state.language
                ],
            })}
          </div>
        ),
      })}
      {Route({
        path: "/scheduling",
        render: () => (
          <div
            class={navSidebarCSS.container}
            onclick={event =>
              actions.autocloseSidebar({
                className: navSidebarCSS.main,
                event,
              })
            }
          >
            {/* {navSidebar({ actions, state })} */}
            {scheduling({
              actions,
              section: "scheduling",
              state,
            })}
          </div>
        ),
      })}
    </Switch>
  );
};
